import React, { HTMLAttributes } from 'react';

import './GridGallery.css';
import cn from 'classnames';
import { WhyWeImage } from '../../App.config';

export interface Item {
    key: string;
    icon?: React.FC<HTMLAttributes<SVGElement>>;
    imgSrc?: WhyWeImage;
    title: string;
    subtitle: string;
    isBig?: boolean;
}

interface Props {
    items: Item[];
}

export const GridGallery: React.FC<Props> = ({ items }) => (
    <div className="GridGallery">
        {items.map(({ key, imgSrc, title, subtitle, icon: Icon, isBig }) => (
            <div className={cn('GridGallery-item', isBig && 'GridGallery-big-item')} key={key}>
                {imgSrc && (
                    <img 
                        src={imgSrc.src} 
                        alt="img" 
                        className="GridGallery-img" 
                        width={imgSrc.width}
                        height={imgSrc.height}
                        style={{ aspectRatio: `${imgSrc.width} / ${imgSrc.height}` }}
                    />
                )}
                {Icon && <Icon />}
                <div className="GridGallery-text">
                    <span className="GridGallery-title">{title}</span>
                    <span className="GridGallery-subtitle">{subtitle}</span>
                </div>
            </div>
        ))}
    </div>
);
